/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取扫码登录二维码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class QrOptionParams {
  constructor(public href: string, public id: string, public state: string) {}
}

export default async function (
  params: QrOptionParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.WxLoginDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/qr-option`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
